import { TokenTimeseriesGroupBy } from "~/modules/token_timeseries/types";
import {
    DistributionSelectProps,
    GroupByProps,
    LegendProps,
    MetricsProps,
    MetricTypes,
    NavigatorProps,
    StackedProps,
} from "./types";

// // // //

// ENHANCEMENT - add feature flag support for this
// ENHANCEMENT - add mobile support to TabSelectV2
export const METRICS_DROPDOWN_OPTIONS = [
    {
        label: "Total Value",
        value: MetricTypes.TotalValue,
        testID: "metric-timeseries-chart--total-value",
        loginRequired: false,
    },
    {
        label: "Asset Holders",
        value: MetricTypes.AssetHolders,
        testID: "metric-timeseries-chart--asset-holders",
        loginRequired: true,
    },
    {
        label: "Active Addresses",
        value: MetricTypes.ActiveAddresses,
        testID: "metric-timeseries-chart--active-addresses",
        loginRequired: true,
    },
    {
        label: "Transfer Volume",
        value: MetricTypes.TransferVolume,
        testID: "metric-timeseries-chart--transfer-volume",
        loginRequired: true,
    },
    {
        label: "Fund Flows",
        value: MetricTypes.MintBurnVolume,
        testID: "metric-timeseries-chart--mint-burn-volumes",
        loginRequired: true,
    },
    {
        label: "7D APY",
        value: MetricTypes.Apy7Day,
        testID: "metric-timeseries-chart--apy-7-day",
        loginRequired: true,
    },
];

export const DEFAULT_LEGEND_PROPS: LegendProps = {
    enabled: true,
    active: true,
    align: "right",
    layout: "vertical",
    verticalAlign: "top",
    itemWidth: 120,
};

export const DEFAULT_NAVIGATOR_PROPS: NavigatorProps = {
    enabled: true,
    active: true,
};

export const DEFAULT_DISTRIBUTION_SELECT_PROPS: DistributionSelectProps = {
    distributed: {
        enabled: true,
    },
    represented: {
        enabled: true,
    },
    stablecoins: {
        enabled: true,
        active: false,
    },
};

export const DEFAULT_STACKED_PROPS: StackedProps = {
    enabled: false,
    active: false,
};

export const DEFAULT_GROUP_BY_PROPS: GroupByProps = {
    enabled: false,
    value: TokenTimeseriesGroupBy.asset,
    allowedOptions: [
        TokenTimeseriesGroupBy.asset,
        TokenTimeseriesGroupBy.token,
        TokenTimeseriesGroupBy.assetClass,
        TokenTimeseriesGroupBy.issuer,
        TokenTimeseriesGroupBy.jurisdictionCountry,
        TokenTimeseriesGroupBy.measure,
        TokenTimeseriesGroupBy.network,
        TokenTimeseriesGroupBy.parentNetwork,
        TokenTimeseriesGroupBy.peggedAsset,
        TokenTimeseriesGroupBy.manager,
        TokenTimeseriesGroupBy.protocol,
        TokenTimeseriesGroupBy.baseProtocol,
        TokenTimeseriesGroupBy.realEstateCountry,
    ],
};

export const DEFAULT_METRICS_PROPS: MetricsProps = {
    options: [
        MetricTypes.TotalValue,
        MetricTypes.AssetHolders,
        MetricTypes.ActiveAddresses,
        MetricTypes.TransferVolume,
    ],
};
